import React from 'react';

const Chat = () => {
  const isUserRegistered = false; // Replace with actual authentication logic if needed.

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-50 text-gray-800">
      {!isUserRegistered && (
        <div className="text-center mb-12">
          <h1 className="text-3xl font-bold mb-4">Access Restricted</h1>
          <p className="text-lg mb-4">
            Our chat feature is available exclusively for registered users. For early access, please contact{' '}
            <a href="mailto:info@ambivert.ai" className="text-blue-500 underline">
              info@ambivert.ai
            </a>
          </p>
        </div>
      )}

      <div className="p-6 bg-gray-50 text-gray-800 max-w-4xl">
        <h1 className="text-4xl font-bold mb-6 text-center">Chat with AI Experts</h1>
        <p className="text-lg mb-4">
          At Ambivert.ai, we bridge the gap between your challenges and AI-driven solutions. Our chat feature connects
          you directly with experts who provide insights tailored to your unique needs.
        </p>
        <p className="text-lg mb-4">
          Whether you're exploring AI for the first time or need guidance on specific use cases, our experts are here
          to help. Discuss your challenges, explore opportunities, and unlock the full potential of AI for your business.
        </p>
        <p className="text-lg">
          Ambivert.ai’s chat system is powered by cutting-edge AI models that provide accurate, actionable advice.
          Engage with confidence and take the next step in your AI journey.
        </p>
      </div>
    </div>
  );
};

export default Chat;